// Every CPx call to netlify/functions/meta-organic goes through here, because that function
// refuses a request without a staff sign-in (Oct 30, 2026). It can publish to our Facebook and
// Instagram and delete comments, and it used to answer anybody who had the URL.
import { getAccessToken } from '../services/auth';

export default function organicFetch(options = {}) {
  const token = getAccessToken();
  return fetch('/.netlify/functions/meta-organic', {
    ...options,
    headers: { ...options.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}
